import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = [
  { n: 1, key: "upload", label: "Documents" },
  { n: 2, key: "profile", label: "Contribuable" },
  { n: 3, key: "analyze", label: "Analyse" },
  { n: 4, key: "review", label: "Revue" },
  { n: 5, key: "legal", label: "Juridique" },
  { n: 6, key: "judgment", label: "Jugement" },
  { n: 7, key: "report", label: "Rapport" },
];

/**
 * WizardStepper — horizontal progress.
 * Props:
 *   current: 1..5 (current step)
 */
export default function WizardStepper({ current = 1 }) {
  return (
    <ol
      className="flex w-full items-center gap-2 overflow-x-auto pb-2 scrollbar-sleek"
      data-testid="wizard-stepper"
      aria-label="Progression du wizard"
    >
      {STEPS.map((s, i) => {
        const done = s.n < current;
        const active = s.n === current;
        return (
          <li
            key={s.key}
            className="flex flex-1 items-center gap-2 min-w-[140px]"
            data-testid={`wizard-step-indicator-${s.n}`}
          >
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition-colors",
                  done && "bg-brand-gold text-white",
                  active && "bg-primary text-primary-foreground ring-2 ring-brand-gold ring-offset-2 ring-offset-background",
                  !done && !active && "bg-muted text-muted-foreground",
                )}
              >
                {done ? <Check className="h-4 w-4" /> : s.n}
              </span>
              <span
                className={cn(
                  "text-sm font-medium",
                  active ? "text-foreground" : "text-muted-foreground",
                )}
              >
                {s.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={cn(
                  "h-px flex-1 transition-colors",
                  done ? "bg-brand-gold" : "bg-border",
                )}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
